// import constCommon from '@/_consts.js';

const defaultState = {
  isLoadding: 0
};

export default defaultState;



// WEBPACK FOOTER //
// ./src/store/modules/setting/defaultState.js